import React from 'react';

import {Box, Grid, Typography} from '@material-ui/core';
import {EfeButtonPrimary, EfeButtonSecondary} from 'components/buttons';

type Props = {
    title?: string;
    message: string;
    handleAccept: () => void;
    handleReject: () => void;
};

function EfeLocationRequest(props: Props) {
    const {title, handleAccept, handleReject, message} = props;

    return (
        <Grid container direction='row' justifyContent='flex-start'>
            <Grid item xs={12}>
                <Box display='flex' flexDirection='row' justifyContent='center' m={2}>
                    {title && (
                        <Typography variant='body1' display='block' gutterBottom color='primary'>
                            {title}
                        </Typography>
                    )}
                </Box>
                <Box display='flex' flexDirection='row' justifyContent='center' m={2}>
                    {message && (
                        <Typography variant='body1' display='block' gutterBottom color='primary'>
                            {message}
                        </Typography>
                    )}
                </Box>
                <Box display='flex' flexDirection='row' justifyContent='center' m={2}>
                    <Grid item xs={4}>
                        <Box m={2}>
                            <EfeButtonSecondary fullWidth onClick={() => handleReject()}>
                                {'Rechazar'}
                            </EfeButtonSecondary>
                        </Box>
                    </Grid>
                    <Grid item xs={4}>
                        <Box m={2}>
                            <EfeButtonPrimary fullWidth onClick={() => handleAccept()}>
                                {'Aceptar'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    );
}

export default EfeLocationRequest;
